<div class="modal-overlay" role="dialog" aria-modal="true">
  <div class="modal-content">

    <!-- Botão de Fechar -->
    <button class="close-btn" (click)="fecharModal(false)" aria-label="Fechar">
      <i class="fa-solid fa-x fa-flip-both"></i>
    </button>

    <!-- Navegação Esquerda -->
    <button class="nav-btn left" (click)="voltar()" aria-label="Imagem anterior">
      ❮
    </button>

    <!-- Imagem Principal -->
    <div class="main-image-wrapper">
      <img 
        [src]="imagens[selectedImageIndex]" 
        alt="Imagem selecionada" 
        class="modal-image"
      />
    </div>

    <!-- Navegação Direita -->
    <button class="nav-btn right" (click)="avancar()" aria-label="Próxima imagem">
      ❯
    </button>

    <!-- Miniaturas -->
    <div class="thumbnails" aria-label="Miniaturas">
      <img 
        *ngFor="let img of imagensThumb; let i = index" 
        [src]="img" 
        [alt]="'Miniatura ' + (i + 1)" 
        class="thumbnail" 
        [class.active]="i === selectedImageIndex"
        (click)="selecionarImagem(i)"
      />
    </div>

  </div>
</div>